import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AlertService } from 'src/app/services/alert.service';
import { Survey } from 'src/app/services/jsonrpc/cms-server.service';
import { CmsService } from 'src/app/services/cms.service';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent implements OnInit {
  public surveys: Survey[];

  constructor(private router: Router, private cms: CmsService, private alert: AlertService, private notification: NotificationsService) {}

  public ngOnInit() {
    this.surveys = null;
    this.cms.cms.surveyList().then(s => {
      this.surveys = s;
    });
  }

  public async updateTitle(survey: Survey, value: string) {
    survey.title = value;
    await this.update(survey);
  }

  public async updateStartDate(survey: Survey, value: Date) {
    survey.start = value?.toISOString();
    await this.update(survey);
  }

  public async updateEndDate(survey: Survey, value: Date) {
    survey.end = value?.toISOString();
    await this.update(survey);
  }

  public createSurvey() {
    return this.router.navigate(['/survey', 'new']);
  }

  public editSurvey(survey: Survey) {
    return this.router.navigate(['/survey', survey.uuid]);
  }

  public evaluateSurvey(survey: Survey) {
    return this.router.navigate(['/survey', survey.uuid, 'results']);
  }

  private async update(survey: Survey) {
    await this.cms.cms
      .surveyUpdate(survey)
      .then(() => this.notification.notify('success', 'Updated', 'The survey was successfully updated.'));
  }

  public async deleteSurvey(survey: Survey) {
    const result = await this.alert.fireWarning(
      `Deleting Survey`,
      `You are about to delete the survey '${survey.title}' and all user evaluations. This action cannot be reverted! Do you want to prorceed?`
    );
    if (result.value) {
      this.surveys = this.surveys.filter(s => survey.uuid != s.uuid);
      await this.cms.cms
        .surveyDelete(survey.uuid)
        .then(() => this.notification.notify('success', 'Updated', 'The survey was successfully deleted.'));
    }
  }
}
